import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import AmplifyTable from '@amplify/amplify-table';
import SelectableTableRow from '../../../../../components/table/SelectableTableRow';
import { splitBooksInformationByValid } from '../../../../../utils/reading/troUtils';
import {
    CLASS_NAME_MAP,
    TABLE_COLUMNS,
    SUMMARY_MEASUREMENTS,
    SUMMARY_INVALID_MEASUREMENTS,
    NOT_DISPLAYING_FIELDS_FOR_SUMMARY,
} from './summaryTableConstants';
import './summaryTable.scss';

const renderTableRow = (renderProps, selectedBookId) => (
    <SelectableTableRow
        {...renderProps}
        troBookDataTestId={renderProps.rowData.id}
        isSelected={selectedBookId === renderProps.rowData.id}
        classNameCallback={isSelected => `content-row ${isSelected ? 'selected' : ''}`}
        cellRenderCallback={(cellKey, value) =>
            !NOT_DISPLAYING_FIELDS_FOR_SUMMARY.includes(cellKey) && (
                <div
                    className={`summary-cell ${CLASS_NAME_MAP[cellKey]}`}
                    key={`${cellKey}-${value}`}
                >
                    {value}
                </div>
            )
        }
    />
);

const SummaryTable = ({ booksInformation, selectBook, selectedBookId }) => {
    const [isCollapsed, setCollapse] = useState(true);
    const { validBooksInformation, invalidBooksInformation } =
        splitBooksInformationByValid(booksInformation);

    const toggleInvalidTable = () => {
        setCollapse(!isCollapsed);
    };

    return (
        <div className="tro-summary-wrapper">
            <AmplifyTable
                key="TRO-summary-table"
                columns={TABLE_COLUMNS}
                rows={validBooksInformation}
                onRowClick={selectBook}
                measurements={SUMMARY_MEASUREMENTS}
                classNames={{
                    className: 'tro-summary-table',
                    headerClassName: 'header-cell',
                    rowClassName: 'header-row',
                }}
                headerRenderer={({ label }) => <div className="summary-cell">{label}</div>}
                rowRenderer={renderProps => renderTableRow(renderProps, selectedBookId)}
            />
            {!isEmpty(invalidBooksInformation) && (
                <>
                    <div className="invalid-results-btn-wrapper">
                        <span
                            role="button"
                            aria-hidden="true"
                            onClick={toggleInvalidTable}
                            className={`invalid-results-btn pointer ${
                                isCollapsed ? 'collapsed' : ''
                            }`}
                        >
                            View Invalidated books <i className="icon-v2-caret-small-up" />
                        </span>
                    </div>

                    {!isCollapsed && (
                        <AmplifyTable
                            key="TRO-summary-invalid-table"
                            columns={TABLE_COLUMNS}
                            rows={invalidBooksInformation}
                            onRowClick={selectBook}
                            measurements={SUMMARY_INVALID_MEASUREMENTS}
                            classNames={{
                                className: 'tro-summary-invalid-table',
                                rowClassName: 'header-row',
                            }}
                            rowRenderer={renderProps => renderTableRow(renderProps, selectedBookId)}
                        />
                    )}
                </>
            )}
        </div>
    );
};
SummaryTable.defaultProps = {
    booksInformation: [],
    selectBook: () => {},
    selectedBookId: '',
};

SummaryTable.propTypes = {
    booksInformation: PropTypes.array,
    selectBook: PropTypes.func,
    selectedBookId: PropTypes.string,
};

export default SummaryTable;
